import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterLink, RouterOutlet } from '@angular/router';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import {
  AsyncStateOverlayModule,
  CustomTranslatorModule,
  PagesModule,
  SharedModule,
  SurveyModule,
} from 'ngx-esprio-shared';
import { AppAuthUIModule } from './auth-ui/app-auth-ui.module';
import { DashboardComponent } from './dashboard-ui/dashboard.components';
import { DashboardInfoBannerComponent } from './dashboard-ui/info-banner/dashboard-info-banner.component';
import { TherapyInfoCardComponent } from './dashboard-ui/therapy-info-card/therapy-info-card.component';
import { DashboardFabComponent } from './dashboard-ui/fab/dashboard-fab.component';
import { LandingPageComponent } from './landing-page-ui/landing-page.component';
import { OnDemandSurveyComponent } from './survey-ui/on-demand-survey/on-demand-survey.component';
import { AppSurveyModule } from './survey/app-survey.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    DashboardComponent,
    DashboardInfoBannerComponent,
    TherapyInfoCardComponent,
    DashboardFabComponent,
    LandingPageComponent,
    OnDemandSurveyComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    CarouselModule.forRoot(),
    CdkTableModule,
    InlineSVGModule,
    BsDatepickerModule,
    RouterLink,
    RouterOutlet,
    CommonModule,
    CustomTranslatorModule,
    AppAuthUIModule,
    AsyncStateOverlayModule,
    AppSurveyModule,
    SurveyModule,
    SharedModule,
    PagesModule,
    FormsModule,
  ],
  providers: [],
})
export class ViewsModule {}
